<template>
  <div class="cmp cmp-page-topbar row-flex">
    <div class="row-flex-main"></div>
    <div class="row-flex-suffix">
      <el-button
        v-if="$route.name !== 'home'"
        class="btn-home"
        type="text"
        size="small"
        icon="el-icon-s-home"
        @click="$router.push('/')"
        >首页</el-button
      >
    </div>
    <div class="row-flex-suffix" v-if="isLogined">
      <el-dropdown @command="dropdownClick">
        <span class="el-dropdown-link">
          <el-avatar size="small" :src="iconAvatar"></el-avatar>
          <span>{{userInfo.phone_}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePwd" icon="el-icon-edit-outline">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="row-flex-suffix" v-else>
      <el-button-group>
        <el-button @click="loginClick" round size="small">登录</el-button>
        <el-button @click="registClick" round size="small">注册</el-button>
      </el-button-group>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/assets/scripts/bus';
import iconAvatar from '@/assets/images/public/avatar.png';

export default {
  name: 'cmpPageTopbar',
  data() {
    return {
      iconAvatar: iconAvatar,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['isLogined']),
  },
  methods: {
    ...mapActions(['logout']),
    loginClick() {
      EventBus.$emit('loginShow');
    },
    registClick() {
      EventBus.$emit('registShow');
    },
    dropdownClick(command) {
      console.log(111, command);
      if (command === 'changePwd') {
        // 修改密码
        EventBus.$emit('forgetPwdShow');
      }
      else if (command === 'logout') {
        // 退出登录
        this.logout().finally(() => {
          this.$router.push({name: 'home'});
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cmp-page-topbar {
  background: linear-gradient(90deg, #6faffe, #1f77e3);
  padding: 8px 20px;
  .btn-home {
    color: #fff;
  }
  .el-dropdown /deep/ .el-dropdown-link {
    color: #fff;
    .el-avatar, span {
      vertical-align: middle;
      margin-left: .5em;
    }
  }
}
</style>
